import { createUseStyles } from 'react-jss';

import { ThemeProps } from '@styles/theme';


export const useStyles = createUseStyles((theme: ThemeProps) => ({
    panelWrapper: {
        borderTop: `1px solid ${theme.colors.grey_light}`,
        paddingTop: theme.spacing(3),
        maxHeight: 'calc(100dvh - 260px)',
        fallbacks: { maxHeight: 'calc(100vh - 260px)' },
        overflowY: 'auto',
        // Tablet (left panel) & phone (drawer): fill the container and scroll
        // vertically instead of capping to a viewport-relative height.
        [theme.down('desktop')]: {
            flex: 1,
            minHeight: 0,
            maxHeight: 'none',
            overflowY: 'auto',
            paddingBottom: 0,
        },
    },

    // The groups list is always a vertical list: on desktop in the left rail,
    // on tablet in the left panel, and on phone inside the slide-in drawer.
    groupsScroller: {
        display: 'contents',
    },

    rowContainer: {
        display: 'flex',
        alignItems: 'center',
        borderBottom: `1px solid ${theme.colors.grey_light}`,
        paddingBottom: theme.spacing(3),
        gap: theme.spacing(2),
        flexWrap: 'nowrap',
        [theme.down('desktop')]: {
            border: 'none',
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
        },
    },

    searchPanel: {
        flex: '1 1 auto',
        minWidth: 0,
        maxWidth: '100%',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.down('desktop')]: {
            paddingLeft: 0,
            paddingRight: 0,
        },
    },

    buttonExport: {
        width: theme.spacing(12),
        minWidth: 'auto',
        height: 36,
        paddingRight: theme.spacing(2),
        margin: 0,
        flexShrink: 0,
    },

    emptyListText: {
        color: theme.colors.grey_text,
        fontSize: 16,
        lineHeight: 1.5,
    },

    addNewGroupButton: {
        marginTop: theme.spacing(6),
    },

    menuItem: {
        maxWidth: '100% !important',
        padding: `${theme.spacing(2)} !important`,
        marginLeft: theme.spacing(1.5),
        marginRight: theme.spacing(1.5),
        [theme.down('desktop')]: {
            marginLeft: theme.spacing(3),
            marginRight: theme.spacing(3),
        },
    },

    loader: {
        color: theme.colors.violet_primary,
        marginRight: 4,
    },
}));
